// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".receipt-link[data-v-03e7b368] {\n  color: #409eff;\n  cursor: pointer;\n}\n.receipt-link[data-v-03e7b368]:hover {\n  text-decoration: underline;\n}", ""]);
// Exports
module.exports = exports;
